import ViewBase from "../../../../../framework/core/mvvm/view_base";
import { PlayerInfo } from "../../hall/hall_view";
import ModelData, { IUserData } from "../../../../public/model_data";
import AppData from "../../../../public/const/app_data";
import GameUtil from "../../../../../utility/game_util";
const { ccclass, property, menu} = cc._decorator;


@ccclass
export default class GoldenBaseView extends ViewBase {

    @property([cc.Node])
    public readonly titleNodes : cc.Node[] = [];

    @property(PlayerInfo)
    public readonly playerInfo: PlayerInfo = new PlayerInfo()
    
    public onShow(args0: any){
        super.onShow(args0);
     
        this.updateTitle();
    }

    private updateTitle(){

        this.titleNodes.forEach(node => {
            node.active = false;
        });

        if (AppData.gameName == "TM_LHD") {

            this.titleNodes[0].active = true;
            
        }else if (AppData.gameName == "TM_TB"){

            this.titleNodes[1].active = true;

        }else if (AppData.gameName == "TM_YXX"){
            
            this.titleNodes[2].active = true;
        }
    }

    public setAvatar(data: IUserData){
        this.playerInfo.avatar.show(true, data.id)
        this.playerInfo.id.string = "ID:" + data.idShow;
    }

    public updateCoin(chip: number){

        this.playerInfo.avatar.showCoinBalance(true)
        this.playerInfo.avatar.refreshCoinBalance(chip)

    }

}